import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {Link, useHistory} from 'react-router-dom'
import { signUpUserStart,  signOutUserStart} from './../redux/User/user.actions'
import Button from './forms/Button'
import FormInput from './forms/FormInput'
import AuthWrapper from './AuthWrapper'


const mapState = ({ user }) => ({
	currentUser: user.currentUser,
	userErr: user.userErr
});

const SignUp = props => {
	
	const dispatch = useDispatch();
	const history = useHistory();
	const { currentUser, userErr } = useSelector(mapState)

	const [EIN, setEIN] = useState('NULL')
	const [contactName, setContactName] = useState('NULL')
	const [contactEmail, setContactEmail] = useState('NULL')

	const [displayName, setDisplayName] = useState('');
	const [address, setAddress] = useState('');
	const [address2, setAddress2] = useState('');
	const [city, setCity] = useState('');
	const [state, setState] = useState('UT');
	const [zip, setZip] = useState('');
	const [phone, setPhone] = useState('');
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [errors, setErrors] = useState([]);
	const [userRoles, setUserRoles] = useState(['customer']);
	const [subscribed, setSubscribed] = useState(false);
	let [fullAddress, setFullAddress] = useState('');
	const [center, setCenter] = useState(0);

	const signOut = () => {
		dispatch(signOutUserStart());
	};

	useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])

	useEffect(() => {
		if(currentUser){
			reset();
			signOut();
			history.push('/login')
		}
		// eslint-disable-next-line
	}, [currentUser]);

	useEffect(() => {
		if (Array.isArray(userErr) && userErr.length > 0){
			setErrors(userErr)
		}
	}, [userErr]);

	fullAddress = `${address} ${address2} ${city}, ${state} ${zip}`


	const reset = () => {

		setEIN('Null');
		setContactName('Null');
		setContactEmail('Null');

		setDisplayName('');
		setAddress('');
		setAddress2('');
		setCity('');
		setState('UT');
		setZip('');
		setPhone('');
		setEmail('');
		setPassword('');
		setConfirmPassword('');
		setUserRoles(['customer']);
		setErrors([]);
		setSubscribed(false);
		setFullAddress('');
		setCenter(0);
	  };

	const handleFormSubmit = event => {
		event.preventDefault();
		dispatch(signUpUserStart({

			EIN,
			contactName,
			contactEmail,

			displayName,
			address,
			address2,
			city,
			state,
			zip,
			phone,
			email,
			password,
			confirmPassword,
			userRoles,
			subscribed,
			fullAddress,
			center
		}))
		
	}
	

	const congfigAuthWrapper = {
		headline: 'Tell Us About Yourself'
	}


	return (
		<AuthWrapper {...congfigAuthWrapper}>
		<form className="py-5 mx-auto" onSubmit={handleFormSubmit}>

			<div className="form-group text-left">
				<label htmlFor="displayName">Full Name</label>
				<FormInput 
					type="text" name="displayName" value={displayName} handleChange={e => setDisplayName(e.target.value)} className="form-control" required
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="address">Address</label>
				<FormInput 
					type="text" name="address" value={address} handleChange={e => setAddress(e.target.value)} className="form-control" required
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="address2">Address 2</label>
				<FormInput 
					type="text" name="address2" value={address2} handleChange={e => setAddress2(e.target.value)} className="form-control" 
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="city">City</label>
				<FormInput 
					type="text" name="city" value={city} handleChange={e => setCity(e.target.value)} className="form-control" required
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="state">State</label>
				<FormInput 
					type="text" name="state" value="UT" handleChange={e => setState(e.target.value)} className="form-control" disabled
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="zip">Zip Code</label>
				<FormInput 
					type="text" pattern="84.[0-9]{2}" title="must start with 84 and max length of 5" name="zip" value={zip} handleChange={e => setZip(e.target.value)} className="form-control" required
				/>
				<span className="text-danger pl-3">*Only northern Utah area supported at this time</span>
			</div>
			<div className="form-group text-left">
				<label htmlFor="phone">Phone</label>
				<FormInput 
					type="number" name="phone" value={phone} handleChange={e => setPhone(e.target.value)} className="form-control" required
				/>
			</div>
			<div className="form-group text-left">
				<label htmlFor="email">Email address</label>
				<FormInput 
					type="email" name="email" value={email} handleChange={e => setEmail(e.target.value)} className="form-control" required
				/>
			</div>

			<div className="form-group text-left">
			<label htmlFor="password">Password</label>
				<FormInput 
					type="password" name="password" value={password} handleChange={e => setPassword(e.target.value)} className="form-control" required
				/>
			</div>
			<div className="form-group text-left">
			<label htmlFor="confirmPassword">Confirm Password</label>
				<FormInput 
					type="password" name="confirmPassword" value={confirmPassword} handleChange={e => setConfirmPassword(e.target.value)} className="form-control" required
				/>
			</div>
			{errors.length > 0 && (
				<ul>
					{errors.map((err, index) => {
					return (
						
						<li key={index} className="text-danger alert text-left">
						{err}
						</li>
					
					);
					})}
				</ul>
			)}
				<Button type="submit">
					REGISTER
				</Button>
	
			<div className="row  py-5">
				<div className="col">
					<h4>Already a member?</h4>
				</div>
				<div className="col">
					<Link to="/login">
						<Button>

							LOGIN
						</Button>
					</Link>
				</div>
			</div>
		</form>
	</AuthWrapper>
	)
}

export default SignUp;





